module.exports = __webpack_public_path__ + "static/img/10013 (3).3f7b73f.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/10000/10013 (3).webp
// module id = CIex
// module chunks = 14